/**
 * Styled Components - Created by david on 12/02/18.
 */
import Popover from 'antd/lib/popover'
import styled from 'styled-components'
import Icon from 'antd/lib/icon'
import { BLACK, BLUE, RED, WHITE } from '../../../../theme/colors'

type StyledProps = {
  backgroundColor?: string
  showTooltips?: boolean
  isHovered?: boolean
  archived?: boolean
  checked?: boolean
  fromNotes?: boolean
}

export const Container = styled.div`
   list-style: none;
   display: inline-block;
   width: ${({ fromNotes }: StyledProps) => fromNotes ? '300px' : '237px'};
   min-width: calc(100% / 4);
   margin-bottom: 25px;
   padding: 0px 4px;
   position: relative;
   transition: all .25s;
   border-radius: 3px;
   border: 1px solid ${({ checked }: StyledProps) => checked ? BLUE : WHITE};
   ${({ fromNotes }: StyledProps) => !fromNotes ? `
    &:hover {
      cursor: pointer;
      box-shadow: 0px 2px 4px 1px #eeeeee;
    }
   ` : ``}
   @media (max-width: 698px) {
    width: 174px;
   }
 `

export const Footer = styled.div`
   padding: 4px;
   font-family: Avenir;
 `

export const DiscontinuedLabel = styled.div`
  background: #e17889;
  padding: 4px 8px;
  font-size: 10px;
  position: absolute;
  z-index: 10;
  right: ${({ archived }: StyledProps) => archived ? '74px' : '11px'};
  top: -9px;
  color: ${WHITE};
  border-radius: 25px;
`

export const ArchivedLabel = styled.div`
  position: absolute;
  z-index: 10;
  right: 11px;
  border-radius: 25px;
  padding: 4px 8px;
  background: #c6c6c6;
  font-size: 10px;
  color: white;
  top: -9px;
`

export const QuickView = styled.img``

export const Type = styled.div`
   color: ${BLACK};
   font-size: 14px;
   line-height: 19px;
   overflow: hidden;
   text-overflow: ellipsis;
   width: 220px;
   display: flex;
   justify-content: space-between;
   @media (min-width: 320px) and (max-width: 480px) {
     width: 100%;
   }
 `

export const EditNotes = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: #7d50a9;
  font-family: Avenir;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: rebeccapurple;
    color: ${WHITE};
    border-radius: 3px;
    padding: 0 4px;
    i {
      color: ${WHITE};
    }
  }
`

export const EditIcon = styled(Icon)`
  transition: all .25s;
  margin-right: 6px;
  color: rebeccapurple;
  border: 1px solid #ab8dc6;
  border-radius: 2px;
  padding: 1px;
  font-size: 10px;
  vertical-align: text-top;
`

export const CodeLabel = styled.div`
  color: #8c8c8c;
  font-size: 12px;
  line-height: 16px;
  padding 2px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 220px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const Description = styled.div`
   user-select: all;
   color: ${BLACK};
   font-size: 12px;
   font-weight: bold;
   line-height: 16px;
   padding 2px 0px;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   width: 220px;
 
   @media (min-width: 320px) and (max-width: 480px) {
     width: 100%;
   }
 `

export const InfoContainer = styled.div`
   user-select: none;
   display: flex;
   flex-direction: row;
   justify-content: space-between;
 `

export const Date = styled.div`
   user-select: none;
   color: #5f6062;
   font-size: 12px;
   line-height: 16px;
 `

export const StatusFlag = styled.img`
  position: absolute;
  height: 50px;
  right: 8px;
  top: 4px;
  z-index: 8;
  ${({ showTooltips }: StyledProps) => showTooltips ? `
    animation: pulse 2s 2s infinite;
    @keyframes pulse {
      0% {
        transform: scale(0.95);
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
      }
    
      70% {
        transform: scale(1);
        filter: drop-shadow(0 0 10px rgba(255, 0, 0, 0));
      }
    
      100% {
        transform: scale(0.95);
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
      }
    }
  ` : ''}
`

export const StyledTooltip = styled(Popover)``

export const TooltipContent = styled.div`
  max-width: 398px;
`

export const StatusIcon = styled.img`
  float: right;
  max-width: 78px;
  margin-left: 8px;
`

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const TooltipContentModal = styled.div`
  max-width: 398px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const buttonStyle = {
  boxShadow: 'none',
  border: 'none',
  background: 'none',
  color: RED
}

export const SpecialNote = styled.div`
  color: ${RED};
  font-size: 13px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CheckoutPrintCheckModal/DesignsPrintModal/ProductThumbnailStore/styledComponents.tsx